let webpSupported = false

window.Modernizr &&
  window.Modernizr.on('webp', result => {
    // Webp disabled indefinitely
    // webpSupported = result
  })

export default function (
  imageObject,
  width = getDeviceWidth(),
  options = { maxWidth: null }
) {
  // Find width rounded up to nearest 100px
  const format = webpSupported ? 'webp' : 'jpg'
  const progressive = format === 'jpg' ? '&fl=progressive' : ''
  const quality = format === 'jpg' ? '&q=60' : ''
  if (width <= 1) width *= getDeviceWidth()
  let w = Math.ceil(width * getDevicePixelRatio() / 100) * 100
  const maxWidth = Math.ceil(options.maxWidth / 100) * 100
  if (maxWidth && w > maxWidth) w = maxWidth
  if (
    !imageObject ||
    !imageObject.fields ||
    !imageObject.fields.file ||
    !imageObject.fields.file.url
  ) {
    return ''
  }
  return `${
    imageObject.fields.file.url
  }?w=${w}&h=${w}&fm=${format}${progressive}${quality}`
}

export const getDeviceWidth = () => window.innerWidth

export const getDevicePixelRatio = () => window.devicePixelRatio || 1



// WEBPACK FOOTER //
// ./src/utils/getImageUrl.js